import {useState} from 'react';
import AbstractFilter from '../../../shared/@types/AbstractFilter';

export default class PortalFilter extends AbstractFilter {
  public busca: any;
  public setBusca: any;
  public numeroAudiencia: any;
  public setNumeroAudiencia: any;
  public codigoAno: any;
  public setCodigoAno: any;
  public codigoSituacao: any;
  public setCodigoSituacao: any;
  public codigoTipoEvento: any;
  public setCodigoTipoEvento: any;
  public ordering: any;
  public setOrdering: any;
  public codigosAreaInteresse: any;
  public setCodigosAreaInteresse: any;

  constructor() {
    super();
    [this.busca, this.setBusca] = useState('');
    [this.numeroAudiencia, this.setNumeroAudiencia] = useState('');
    [this.codigoAno, this.setCodigoAno] = useState('');
    [this.codigoSituacao, this.setCodigoSituacao] = useState('');
    [this.codigoTipoEvento, this.setCodigoTipoEvento] = useState('');
    [this.ordering, this.setOrdering] = useState('ano');
    [this.codigosAreaInteresse, this.setCodigosAreaInteresse] = useState([]);
  }

  limpar() {
    this.setBusca('');
    this.setNumeroAudiencia('')
    this.setCodigoAno('')
    this.setCodigoSituacao(2)
    this.setCodigoTipoEvento('')
    this.setOrdering('ano');
  }
}
